import classNames from "classnames";
import { Typography } from "components/atoms/Typography";
import { HorizontalProgressBar } from "components/molecules/HorizontalProgressBar";
import { Button } from "components/atoms/Button";
import "./index.scss";

interface DataProps {
  complete?: number;
  total?: number;
  filled?: number;
  label?: string;
  labelSecondary?: string;
  progressColor?: string;
}

interface IProps {
  dataSet?: DataProps[];
  styles?: string;
  handleClick?: () => void;
}

export const HorizontalProgressBarCard = ({
  dataSet,
  styles,
  handleClick,
}: IProps) => {
  return (
    <div
      className={classNames("progress-bar-container", {
        [`${styles}`]: styles,
      })}
      onClick={handleClick}
    >
      <div className="card-header">
        <Typography variant="h6Bold" label="Test Scores & Performance" />
      </div>
      <div className="bar-section">
        {dataSet &&
          dataSet.map((item: any, index: number) => (
            <div className="horizontal-bar" key={index}>
              <HorizontalProgressBar
                complete={item.complete}
                total={item.total}
                filled={item.filled}
                label={item.label}
                labelSecondary={item.labelSecondary}
                progressColor={item.progressColor}
                topic=""
              />
            </div>
          ))}
      </div>
      <div className="btn-section">
        <Button
          label="View Scores"
          type="score"
          icon={false}
          styles="horizontal-progress-bar-card-btn"
          onClick={handleClick}
        />
      </div>
    </div>
  );
};
